// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert,
  Table,
} from "react-bootstrap";
import ReactAutocomplete from "react-autocomplete";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import moment from "moment";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "../dashboard/dashboard.scss";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import { voucherStatus } from "../../../redux/actions/frontActions";
import logo from "../../../img/ddb-logo.png";
import languageConfig from "../../../config/languageConfig";
import { Notification } from "../../../components/notifications";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import NumberFormat from "react-number-format";

import Cookies from "universal-cookie";
import { getVoucherSpecificDetails } from "../../../redux/actions/voucherActions";

import { userVoucherList } from "../../../redux/actions/frontActions";

const cookies = new Cookies();
const history = createBrowserHistory();

const menuCss = {
  position: "absolute",
  display: "block",
  width: "100%",
  zIndex: 1,
  border: "1px solid #ddd",
  maxHeight: "200px",
  overflowY: "auto",
};

let cart = "";
class GiftRedeem extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      email: "",
      orderID: "",
      showAlert: false,
      disabled: false,
      orderList: "",
      hover: false,
      redeem_amount: "",
      customerSpendAmt: "",
      vouchersList: [],
      vouchersListData: [],
      voucherDetails: "",
      voucherNumberError: "",
      redeemAmountError: "",
      changeVoucherNumber: false,
      showVoucherDetails: false,
      disableRedeemAmount: true,
      default_lang: "en",
      //default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
      voucherID: "",
      cancel: false,
      voucherDetailList: "",
      user_id: "",
      default_lang: cookies.get("default_lang")
        ? cookies.get("default_lang")
        : "en",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeVoucherNumber = this.onChangeVoucherNumber.bind(this);
    this.onSelectVoucherNumber = this.onSelectVoucherNumber.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.handleCancel = this.handleCancel.bind(this);
    this.viewVoucherDetails = this.viewVoucherDetails.bind(this);

    this.Clear = this.Clear.bind(this);
  }

  hoverOn = (e) => {
    this.setState({
      hover: true,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  hoverOff = (e) => {
    this.setState({
      hover: false,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ disabled: false });
  };

  onChangeVoucherNumber = (e) => {
    this.setState({ voucherNumber: e.target.value });
    let vouchersList = this.state.vouchersListData.filter(
      (item) =>
        item.voucherNumber
          .toLowerCase()
          .search(e.target.value.toLowerCase()) !== -1
    );
    const disReedAmnt = e.target.value ? false : true;
    this.setState({
      vouchersList: vouchersList,
      showVoucherDetails: false,
      disableRedeemAmount: disReedAmnt,
      voucherDetails: "",
      voucherID: "",
    });
  };

  onSelectVoucherNumber = (voucherNumber, item) => {
    this.setState({
      voucherNumber,
      changeVoucherNumber: true,
      voucherID: item.voucherID,
    });
    this.props.getVoucherSpecificDetails(item.voucherID);
  };

  handleDismiss() {
    this.setState({ showAlert: false });
  }

  handleShow() {
    this.setState({ showAlert: true });
  }

  Clear() {
    this.setState({
      voucherNumber: "",
    });
  }

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    siteData.default_lang = lang;
    localStorage.setItem("siteDDBStatus", JSON.stringify(siteData));
    this.setState({
      default_lang: lang,
    });

    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang);
    this.props.getMenuList({
      page: 1,
      lang: lang,
      cityID: siteData.default_city,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({ userKey: cookies.get("token"), lang: lang });
    }
  };

  handlePageChange = (page) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({
        userKey: cookies.get("token"),
        lang:
          siteData && siteData.default_lang
            ? siteData.default_lang
            : this.state.default_lang,
      });
    }
  };

  componentDidMount() {
    let userID = localStorage.getItem("user_id")
      ? localStorage.getItem("user_id")
      : "";
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    this.setState({
      user_id: userID,
    });
    if (userID) {
      this.props.userVoucherList({ voucherType: "gift_card" });
    }
  }

  componentWillMount() {
    if (this.props.themeData) {
      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }

    let voucherIDParams = this.props.route.match.params.voucherID
      ? this.props.route.match.params.voucherID
      : "";
    if (voucherIDParams) {
      this.setState({
        voucherNumber: voucherIDParams,
        disableRedeemAmount: false,
      });
      this.props.getVoucherSpecificDetails(voucherIDParams);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.language) {
      if (this.state.default_lang !== nextProps.language) {
        this.setState({ default_lang: nextProps.language });
      }
    }

    if (nextProps.themeData) {
      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }

    if (this.props.voucherList !== nextProps.voucherList) {
      if (nextProps.voucherList) {
        this.setState({
          vouchersListData: nextProps.voucherList.data,
        });
      }
    }

    if (
      this.props.voucherSpecificDetails !== nextProps.voucherSpecificDetails
    ) {
      if (nextProps.voucherSpecificDetails) {
        this.setState({
          voucherDetails: nextProps.voucherSpecificDetails.data,
          showVoucherDetails: true,
          disableRedeemAmount: false,
        });
      }
    }

    if (this.props.orderRedeem != nextProps.orderRedeem) {
      if (nextProps.orderRedeem) {
        this.setState({ disabled: false });
        this.setState({ showAlert: true });
        this.handleShow();
        this.props.renderAlert("success", nextProps.orderRedeem.message);
        this.setState({ redeem_amount: "" });
        this.setState({ customerSpendAmt: "" });
        if (this.state.voucherID) {
          this.props.getVoucherSpecificDetails(this.state.voucherID);
        }
        window.scrollTo(0, 0);
      }
      if (
        nextProps.orderRedeem &&
        nextProps.orderRedeem.viewBy == "VoucherDetail"
      ) {
        this.setState({
          voucherDetailList: nextProps.orderRedeem.data,
        });
      } else {
        this.setState({
          voucherDetailList: "",
        });
      }
    }

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        this.setState({ showAlert: true });
        this.setState({ disabled: false });
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        if (this.state.voucherID) {
          this.props.getVoucherSpecificDetails(this.state.voucherID);
        }
        window.scrollTo(0, 0);
        if (
          nextProps.error == "Unauthenticated." ||
          nextProps.error == "Unauthenticated"
        ) {
          auth.clearAllAppStorage();
          localStorage.removeItem("user");
          localStorage.removeItem("user_id");
          localStorage.removeItem("userTypeName");
          localStorage.removeItem("userTypeID");
          localStorage.removeItem("siteID");
          localStorage.removeItem("user_sec_id");
          this.context.router.history.push("/login");
        }
      }
    }

    if (this.props.message !== nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
      //Clear();
    }
  }

  componentWillUpdate(nextProps, nextState) {}

  validate = () => {
    let isError = false;
    const errors = {};

    if (!this.state.voucherNumber) {
      isError = true;
      this.setState({ voucherNumberError: "red" });
    }

    if (!this.state.redeem_amount) {
      isError = true;
      this.setState({ redeemAmountError: "red" });
    }

    return isError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const err = this.validate();

    if (!err) {
      this.setState({ disabled: true });
      this.props.voucherStatus({
        voucherNumber: this.state.voucherNumber,
        redeem_amount: this.state.redeem_amount,
        lang: this.state.default_lang,
        voucher_type: "gift_card",
        redeemedBy: "Merchant",
        customerSpendAmt: this.state.customerSpendAmt,
      });
    }
  };

  viewVoucherDetails = (voucherNumber) => {
    this.props.voucherStatus({
      voucherNumber: voucherNumber,
      lang: this.state.default_lang,
      redeemedBy: "Merchant",
      buttonBy: "viewDetail",
      voucher_type: "gift_card",
    });
    this.setState({ cancel: false });
  };

  handleCancel = (e) => {
    this.setState({
      cancel: true,
      voucherDetailList: "",
      showAlert: false,
      showVoucherDetails: false,
      voucherDetails: "",
    });
  };

  render() {
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div className="container">
            <Col md={6} mdOffset={3}>
              <div className="panel margin-top">
                <header className="panel-heading text-center text-default">
                  {languageConfig[this.state.default_lang].redeem_voucher}
                </header>
                <div className="panel-body">
                  {this.state.showAlert && this.state.alertMessage !== "" && (
                    <div className="col-lg-12">
                      <Alert
                        bsStyle={
                          this.state.alertMessage ==
                            "This voucher is expired.  To redeem the  Paid value, select Redeem" ||
                          this.state.alertMessage ==
                            "Ce bon est expiré. Pour échanger la valeur payée, sélectionnez Échanger" ||
                          this.state.alertMessage ==
                            "Here are the voucher details. Scroll down to redeem."
                            ? "warning"
                            : this.state.msgType
                        }
                        onDismiss={this.handleDismiss}
                      >
                        <strong>
                          {this.state.msgType === "warning"
                            ? "Warning"
                            : this.state.alertMessage ==
                                "This voucher is expired.  To redeem the  Paid value, select Redeem" ||
                              this.state.alertMessage ==
                                "Ce bon est expiré. Pour échanger la valeur payée, sélectionnez Échanger" ||
                              this.state.alertMessage ==
                                "Here are the voucher details. Scroll down to redeem."
                            ? ""
                            : " "}{" "}
                        </strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </div>
                  )}
                  <Row>
                    <Col md={12} xs={12}>
                      <strong>
                        {languageConfig[this.state.default_lang].do_not_mark}
                      </strong>
                    </Col>
                    <Col md={12} xs={12}></Col>
                    <Col md={12} xs={12}>
                      <FormGroup>
                        <ControlLabel>
                          {
                            languageConfig[this.state.default_lang]
                              .voucher_number
                          }
                        </ControlLabel>
                        <ReactAutocomplete
                          inputProps={{
                            style: {
                              borderColor: this.state.voucherNumberError,
                            },
                            class: "form-control",
                          }}
                          wrapperProps={{
                            style: { display: "block", position: "relative" },
                          }}
                          items={this.state.vouchersList}
                          getItemValue={(item) => item.voucherNumber}
                          renderItem={(item, isHighlighted) => (
                            <div
                              class="item"
                              key={item.voucherNumber}
                              style={{
                                padding: "2px 5px",
                                background: isHighlighted
                                  ? "lightgray"
                                  : "white",
                              }}
                            >
                              {item.voucherNumber}
                            </div>
                          )}
                          renderMenu={(items, value) => (
                            <div className="menu" style={menuCss}>
                              {items.length === 0 ? (
                                <div className="item">
                                  No matches for {value}
                                </div>
                              ) : (
                                items
                              )}
                            </div>
                          )}
                          value={this.state.voucherNumber}
                          onChange={this.onChangeVoucherNumber}
                          onSelect={this.onSelectVoucherNumber}
                          autoComplete={false}
                        />
                        {this.state.voucherNumberError && (
                          <span>Please enter a valid gift voucher number</span>
                        )}
                      </FormGroup>
                      <div>
                        {((this.state.showVoucherDetails &&
                          this.state.voucherDetails !== "") ||
                          (this.state.voucherDetailList &&
                            this.state.voucherDetailList !== "" &&
                            this.state.cancel == false)) && (
                          <Table
                            striped
                            bordered
                            condensed
                            hover
                            className="voucherDetails"
                          >
                            <tbody>
                              <tr>
                                <td xs={3} md={4}>
                                  {
                                    languageConfig[this.state.default_lang]
                                      .offer_name
                                  }
                                </td>
                                <td xs={9} md={4}>
                                  {this.state.voucherDetails.dealText
                                    ? this.state.voucherDetails.dealText
                                    : this.state.voucherDetailList.dealText}
                                </td>
                              </tr>
                              <tr>
                                <td xs={3} md={4}>
                                  {
                                    languageConfig[this.state.default_lang]
                                      .merchant_name
                                  }
                                </td>
                                <td xs={9} md={4}>
                                  {this.state.voucherDetails.merchantName
                                    ? this.state.voucherDetails.merchantName
                                    : this.state.voucherDetailList.merchantName}
                                </td>
                              </tr>
                              <tr>
                                <td xs={3} md={4}>
                                  {
                                    languageConfig[this.state.default_lang]
                                      .amount_remaining
                                  }
                                </td>
                                <td xs={9} md={4}>
                                  {this.state.voucherDetails.voucherValue
                                    ? parseFloat(
                                        this.state.voucherDetails.voucherValue -
                                          this.state.voucherDetails
                                            .totalRedeemed
                                      ).toFixed(2)
                                    : parseFloat(
                                        this.state.voucherDetailList
                                          .voucherValue -
                                          this.state.voucherDetailList
                                            .totalRedeemed
                                      ).toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td xs={3} md={4}>
                                  {
                                    languageConfig[this.state.default_lang]
                                      .voucher_value
                                  }
                                </td>
                                <td xs={9} md={4}>
                                  {this.state.voucherDetails.voucherValue
                                    ? parseFloat(
                                        this.state.voucherDetails.voucherValue
                                      ).toFixed(2)
                                    : parseFloat(
                                        this.state.voucherDetailList
                                          .voucherValue
                                      ).toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td xs={3} md={4}>
                                  {
                                    languageConfig[this.state.default_lang]
                                      .purchase_price
                                  }
                                </td>
                                <td xs={9} md={4}>
                                  {this.state.voucherDetails.purchasePrice
                                    ? this.state.voucherDetails.purchasePrice
                                    : this.state.voucherDetailList
                                        .purchasePrice}
                                </td>
                              </tr>
                              <tr>
                                <td xs={3} md={4}>
                                  {
                                    languageConfig[this.state.default_lang]
                                      .purchase_date
                                  }
                                </td>
                                <td xs={9} md={4}>
                                  {this.state.voucherDetails.createdOn
                                    ? moment(
                                        this.state.voucherDetails.createdOn
                                      ).format("ll")
                                    : this.state.voucherDetailList.purchaseDate
                                    ? moment(
                                        this.state.voucherDetailList
                                          .purchaseDate
                                      ).format("ll")
                                    : ""}
                                </td>
                              </tr>
                              <tr>
                                <td xs={3} md={4}>
                                  {
                                    languageConfig[this.state.default_lang]
                                      .expiry_date
                                  }
                                </td>
                                <td xs={9} md={4}>
                                  {this.state.voucherDetailList.never_expires ? 'Never Expire' : this.state.voucherDetails.expiryDate
                                    ? moment(
                                        this.state.voucherDetails.expiryDate
                                      ).format("ll")
                                    : this.state.voucherDetailList.expiryDate
                                    ? moment(
                                        this.state.voucherDetailList.expiryDate
                                      ).format("ll")
                                    : ""}
                                </td>
                              </tr>
                              <tr>
                                <td xs={3} md={4}>
                                  {
                                    languageConfig[this.state.default_lang]
                                      .fine_print
                                  }
                                </td>
                                <td xs={9} md={4}>
                                  {this.state.voucherDetails.termsAndConditions
                                    ? ReactHtmlParser(
                                        this.state.voucherDetails
                                          .termsAndConditions
                                      )
                                    : this.state.voucherDetailList
                                        .termsAndConditions
                                    ? ReactHtmlParser(
                                        this.state.voucherDetailList
                                          .termsAndConditions
                                      )
                                    : "-"}
                                </td>
                              </tr>
                              <tr>
                                <td xs={3} md={4}>
                                  {
                                    languageConfig[this.state.default_lang]
                                      .voucher_status
                                  }
                                </td>
                                <td xs={9} md={4}>
                                  {this.state.voucherDetails.status
                                    ? this.state.voucherDetails.status
                                    : this.state.voucherDetailList.status}
                                  {this.state.voucherDetails.status ==
                                  "Redeemed"
                                    ? " At " +
                                      moment(
                                        this.state.voucherDetails.redeemed_at
                                      ).format("lll")
                                    : this.state.voucherDetailList.status ==
                                      "Redeemed"
                                    ? " At " +
                                      moment(
                                        this.state.voucherDetailList.redeemed_at
                                      ).format("lll")
                                    : ""}
                                </td>
                              </tr>
                              <tr>
                                <td xs={3} md={4}>
                                  {
                                    languageConfig[this.state.default_lang]
                                      .customer_spend
                                  }
                                </td>
                                <td xs={9} md={4}>
                                  {this.state.voucherDetails.customerSpendAmt
                                    ? this.state.voucherDetails.customerSpendAmt
                                    : this.state.voucherDetailList
                                        .customerSpendAmt
                                    ? this.state.voucherDetailList
                                        .customerSpendAmt
                                    : "-"}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        )}
                      </div>
                      <FormGroup>
                        <ControlLabel>
                          {
                            languageConfig[this.state.default_lang]
                              .redeem_amount
                          }
                        </ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.redeem_amount}
                          max={parseFloat(
                            this.state.voucherDetails.voucherValue -
                              this.state.voucherDetails.totalRedeemed
                          ).toFixed(2)}
                          placeholder="Enter Amount"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.redeemAmountError }}
                          name="redeem_amount"
                          autoComplete="off"
                          disabled={this.state.disableRedeemAmount}
                          required
                        />
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>
                          {
                            languageConfig[this.state.default_lang]
                              .customer_spend
                          }{" "}
                          ({languageConfig[this.state.default_lang].optional})
                        </ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.customerSpendAmt}
                          placeholder="Total Customer Spend Amount"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.customerSpendAmt }}
                          name="customerSpendAmt"
                          autoComplete="off"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} xs={12}>
                      <Button
                        bsStyle="success"
                        style={{
                          backgroundColor:
                            this.state.hover && this.state.hoverID == "order"
                              ? this.state.mouseover_color
                              : this.state.button_color
                              ? this.state.button_color
                              : "#77C84E",
                        }}
                        data-id={"order"}
                        onMouseEnter={this.hoverOn}
                        onMouseLeave={this.hoverOff}
                        type="submit"
                        disabled={this.state.disabled}
                      >
                        {languageConfig[this.state.default_lang].redeem}
                      </Button>
                      {(this.state.voucherDetailList &&
                        this.state.voucherDetailList !== "") ||
                      (this.state.showVoucherDetails &&
                        this.state.voucherDetails !== "") ? (
                        <Button
                          bsStyle="danger"
                          onClick={this.handleCancel.bind(this)}
                        >
                          {languageConfig[this.state.default_lang].cancel}
                        </Button>
                      ) : (
                        <Button
                          bsStyle="success"
                          style={{
                            backgroundColor:
                              this.state.hover &&
                              this.state.hoverID == "viewDetail"
                                ? this.state.mouseover_color
                                : this.state.button_color
                                ? this.state.button_color
                                : "#77C84E",
                          }}
                          onMouseEnter={this.hoverOn}
                          onMouseLeave={this.hoverOff}
                          data-id={"viewDetail"}
                          onClick={this.viewVoucherDetails.bind(
                            this,
                            this.state.voucherNumber
                          )}
                        >
                          {languageConfig[this.state.default_lang].view_details}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </div>
        </form>
      </div>
    );
  }
}

GiftRedeem.propTypes = {
  voucherStatus: PropTypes.func.isRequired,
  voucherList: PropTypes.func.isRequired,
  voucherSpecificDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: state.frontReducer.error,
  orderRedeem: state.frontReducer.ordertracking,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  voucherList: state.frontReducer.voucherList,
  voucherSpecificDetails: state.voucherReducer.voucherSpecificDetails,
});

export default compose(
  connect(mapStateToProps, {
    voucherStatus,
    renderAlert,
    clearAlert,
    userVoucherList,
    getVoucherSpecificDetails,
  })
)(GiftRedeem);



// WEBPACK FOOTER //
// ./src/app/views/frontend/user/GiftRedeem.js